export const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];
export const NS = {
  svg: 'http://www.w3.org/2000/svg'
};
export const MS = {
  d: 86400000
};
export const E = (() => {
  // const touchSupport = location.hostname !== 'localhost';
  const touchSupport = Boolean(
    'ontouchstart' in window || window['TouchEvent'] || window['DocumentTouch']
  );

  return {
    move: touchSupport ? 'touchmove' : 'mousemove',
    start: touchSupport ? 'touchstart' : 'mousedown',
    end: touchSupport ? 'touchend' : 'mouseup'
  };
})();
export const themePresets = {
  light: {
    '--anim-dur': '250',
    '--theme_name': 'light',
    '--theme_switch_text': '"Switch to Night Mode"',
    '--body-bg': '#fff',
    '--body-color': '#000',
    '--crt-line-bg': '1px 1px 0 0 #eee',
    '--crt-label-color': '#96a2aa',
    '--crt-tooltip-bg': '#fff',
    '--crt-legend': '#43484b',
    '--hvr-box-bg': '#fff',
    '--hvr-box-shadow': '1px 1px 4px 0 rgba(0, 0, 0, 0.08)',
    '--minimap-window-border': 'rgba(84, 149, 194, 0.2)',
    '--minimap-window-outline': 'solid rgba(244, 247, 252, 0.8) 100vw'
  },
  dark: {
    '--anim-dur': '250',
    '--theme_name': 'dark',
    '--theme_switch_text': '"Switch to Day Mode"',
    '--body-bg': '#242f3e',
    '--body-color': '#fff',
    '--crt-line-bg': '1px 1px 0 0 #3b4a5a',
    '--crt-label-color': '#546778',
    '--crt-tooltip-bg': '#242f3e',
    '--crt-legend': '#e8ecee',
    '--hvr-box-bg': '#242f3e',
    '--hvr-box-shadow': '1px 1px 4px 1px rgba(0, 0, 0, 0.2)',
    '--minimap-window-border': 'rgba(128, 176, 210, 0.3)',
    '--minimap-window-outline': 'solid rgba(29, 39, 54, 0.7) 100vw'
  }
};
